import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const guestGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Auth is guaranteed to be initialized by APP_INITIALIZER
  if (!authService.isAuthenticated()) {
    return true;
  }

  // If user is already authenticated, redirect to dashboard
  router.navigate(['/dashboard']);
  return false;
};
